import React, { createContext, useContext, useState, useEffect } from 'react';
import API, { api } from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);       // { username, rank, profile_picture, ... }
    const [loading, setLoading] = useState(true);
    const [authenticated, setAuthenticated] = useState(false);

    const checkAuth = async () => {
        try {
            const data = await api.get(API.CHECK_AUTH);
            if (data.status === 'success') {
                setAuthenticated(true);
                const profile = await api.get(API.USER_PROFILE);
                if (profile.status !== 'error') {
                    setUser(profile);
                }
            } else {
                setAuthenticated(false);
                setUser(null);
            }
        } catch {
            setAuthenticated(false);
            setUser(null);
        } finally {
            setLoading(false);
        }
    };

    const login = async (username, password, rememberMe) => {
        const data = await api.post(API.LOGIN, { username, password, remember_me: rememberMe });
        if (data.status === 'success') {
            await checkAuth();
        }
        return data;
    };

    const logout = async () => {
        await api.post(API.LOGOUT, {});
        setUser(null);
        setAuthenticated(false);
    };

    useEffect(() => { checkAuth(); }, []);

    return (
        <AuthContext.Provider value={{ user, setUser, loading, authenticated, login, logout, checkAuth }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const context = useContext(AuthContext);
    if (!context) throw new Error('useAuth must be used within AuthProvider');
    return context;
}
